import classnames from 'classnames';
import s from './index.module.scss';

export const RadioButton = ({ className, ...props }) => (
  <div className={classnames(s.radio_button, className, 'radio_button')}>
    <input type="radio" {...props} />
    <span className={s.radio_button__checkmark} />
  </div>
);
